import React, { Component } from 'react';
import FooterComponent from '../components/footer';
import { connect } from 'react-redux';
import * as initActions from './../actions/init';

class FooterContainer extends Component {
    componentDidMount() {
        this.props.listenWindow();
    }

    render() {
        const { timeData } = this.props;
        return <FooterComponent isIntro={this.props.isIntro} timeData={timeData} />;
    }
}


const mapStatetoProps = (state) => {
    return state;
};

export default connect(mapStatetoProps, { ...initActions })(FooterContainer);


// WEBPACK FOOTER //
// /src/containers/FooterContainer.js